import axios from 'axios';

const GET_CIRCULATION_GAMES = 'circulations/circulationGames';
const GET_CIRCULATIONS = 'circulations/filter';

const getCirculationGames = (id) =>
  axios.get(`${GET_CIRCULATION_GAMES}?id=${id}`);

const getExactTicketsCount = (ticketGames = [], circulationId) =>
  axios({
    url: `tickets/exactTicketsCount`,
    method: 'POST',
    data: {
      ticketGames: ticketGames.map((game) => ({
        gameId: game.id,
        option1: game.option1,
        optionX: game.optionX,
        option2: game.option2,
      })),
      circulationId,
    },
  });

const createVoidTicket = (ticketGames, circulationId, type) =>
  axios.post(`voidTickets/create`, {
    ticketGames,
    circulationId,
    type,
  });

const getCirculations = () =>
  axios.get(`${GET_CIRCULATIONS}`, {
    params: { isActive: true, isExpired: false },
  });

export {
  createVoidTicket,
  getCirculationGames,
  getCirculations,
  getExactTicketsCount,
};
